<template>
  <div class="flex flex-col w-full border-b border-grey-academy-150">
    <div class="flex items-center w-full justify-between
      py-3 text-sm lg:text-lg">
      <div class=" flex flex-col px-2 lg:w-1/6 w-1/8 text-left font-black" v-if="lesson.slot">
        <span> {{ dayStart }} </span>
        <span>{{ hourStart }} - {{ hourEnd }} </span>
      </div>
      <span class="px-2 w-1/2 md:w-1/4"> {{ lesson.tier.name }} </span>
      <span class="px-2 w-1/12 hidden md:block" v-if="lesson.slot">
        {{ lesson.slot.duration }} min
      </span>
      <span class="px-2 w-1/12 hidden md:block">
        {{ formatter.format(lesson.total_to_pay/100) }}
      </span>
      <div v-if="lesson.status !== 'canceled'" class="flex w-1/4 justify-end">
        <button v-if="showStartButton(lesson)"
        class="bg-beige-academy-300 rounded md:p-1 p-0 text-white uppercase text-xs md:text-base
        font-bold border-2 border-beige-academy-300 hover:bg-white hover:text-beige-academy-400
        hidden md:block mr-10"
        @click="startLesson" :class="isLoading ? 'loader' : ''">
          {{ $t('lesson.startLesson') }}
        </button>
        <button @click="open = !open" v-show="!lesson.ended && !open">
          <arrow-down-icon class="w-6 lg:w-10 pointer-events-none" />
        </button>
        <button v-show="open && !lesson.ended" @click="open = !open">
          <arrow-up-icon class="w-6 lg:w-10 pointer-events-none" />
        </button>
      </div>
      <div v-else class="uppercase font-bold text-red-500">
        {{ $t('lesson.canceled') }}
      </div>
    </div>
    <div v-if="open && !lesson.ended"
    class="flex flex-col items-center justify-between pb-6 pt-3 ml-2 w-full">
    <div class="w-full text-left flex items-center justify-between flex-wrap mb-6"
    v-if="lesson.comments">
      <div class="flex items-center text-xs md:text-base">
        <div class="font-bold mr-2">{{$t('lesson.comments')}}</div>
        <span>{{ lesson.comments }}</span>
      </div>
    </div>
      <div v-if="!lesson.slide_url" class="flex items-center w-full">
        <span class="font-sans-serif">{{$t('masterclass.no-slides')}}</span>
        <button @click="openFileManager"
          class="ml-4 rounded-full shadow-md w-auto p-0 md:p-2 border border-grey-academy-200
          text-md uppercase text-left transform hover:-translate-y-1 duration-300 bg-white">
            {{$t('masterclass.load-slides')}}
        </button>
      </div>
      <div class="flex w-full justify-between md:hidden">
        <span class="pt-2 md:pt-0 px-2 w-full md:hidden flex justify-center">
          {{ formatter.format(lesson.total_to_pay/100) }} </span>
        <span class="pt-2 md:pt-0 px-2 w-full md:hidden flex justify-center">
          {{ lesson.slot.duration }} min </span>
      </div>
      <button v-if="showStartButton(lesson)"
        class="bg-beige-academy-300 rounded p-1 text-white uppercase text-xs md:text-base
        font-bold border-2 border-beige-academy-300 hover:bg-white hover:text-beige-academy-400
        block md:hidden mt-2"
        @click="startLesson" :class="isLoading ? 'loader' : ''">
          {{ $t('lesson.startLesson') }}
      </button>
      <div v-if="lesson.slide_url" class="">
        <span class="text-beige-academy-500">{{lesson.slide_name}}</span>
        <button @click="openFileManager"
          class="ml-4 border-b border-orange-academy-300 mx-auto
          text-md px-2 uppercase text-left transform hover:-translate-y-1 duration-300">
            {{$t('masterclass.change-slides')}}
        </button>
      </div>
    </div>
    <div v-if="lesson.ended" class="text-left text-beige-academy-500">
      <span v-if="lesson.review" class="text-chocolate-academy-600">
        {{ $t('lesson.reviewScore') }}: {{lesson.review.teacher_avg}}
      </span>
      <span v-if="lesson.reviewn && lesson.status !== canceled">{{ $t('lesson.noReviews') }}</span>
    </div>
  </div>
</template>

<script>
import { getTeacherUrl } from '@/services/LessonService';
import LessonMixin from '@/mixins/LessonMixin';
import ArrowDownIcon from '../graphics/ArrowDownIcon.vue';
import ArrowUpIcon from '../graphics/ArrowUpIcon.vue';
import FileUploader from '../fileUpload/FilesManager.vue';

export default {
  components: { ArrowDownIcon, ArrowUpIcon },
  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      open: !!this.lesson.slide_url,
      isLoading: false,
    };
  },

  mixins: [LessonMixin],

  methods: {
    startLesson() {
      this.isLoading = true;
      getTeacherUrl(this.lesson.booking_id).then(({ data }) => {
        window.location.href = data;
        this.isLoading = false;
      }).catch((errors) => {
        this.isLoading = false;
        console.log(errors);
      });
    },
    openFileManager() {
      this.$modal.show(FileUploader, {
        id: this.lesson.lesson_id, isLesson: true,
      }, { adaptive: true, height: 'auto' });
    },
  },
};
</script>
